import { post, get, destroy } from "./api";

export const BlogApi = {
  blogList: (type = "") => get(`/blogs?type=${type}`),
  blogListByUser: () => get("/blogs/user"),
  blogDelete: (id) => destroy(`/blogs/delete/${id}`),
  createBlog: (data) => post("/blogs/", data),
  blogById: (id) => get(`/blogs/${id}`),
};
